import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { WarrantyForm } from "../components/WarrantyForm";

type IProps = Immutable<templates.WarrantyFormTemplate>;

export const Template = (props: IProps): React.ReactNode => {
    return (
        <WarrantyForm
            value={props.value}
            propertyName={props.property_name}
            claimURL={props.claim_url}
        />
    );
};
